import { fetchProjects } from 'api/firestore/managementData';
import { useAuthInfo } from 'auth';

interface getProjectsParameters {
  sort?: number;
  limit?: number;
  offset?: number;
}

export const useGetProjects = () => {
  const { currentUser } = useAuthInfo();
  const getProjects = (data: getProjectsParameters) => fetchProjects(currentUser, data);

  return { getProjects };
};
